<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="订单号" style="width: 200px" size="small" clearable></el-input>
        <el-input v-model="keyword2" placeholder="伞型" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-input v-model="keyword3" placeholder="规格" style="width: 200px;margin-left: 5px;" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <div style="margin-top: 10px;">
          <el-date-picker v-model="today" type="date" placeholder="选择日期" @change="search"
            :clearable="false" :editable="false"></el-date-picker>
        </div>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <!-- <el-table-column align="center" label="ID" width="80" prop="id"></el-table-column> -->
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="订单号" min-width="100" prop="dingdanhao"></el-table-column>
          <el-table-column align="center" label="伞型" min-width="100" prop="sanxing"></el-table-column>
          <el-table-column align="center" label="规格" min-width="100" prop="guige"></el-table-column>
          <el-table-column align="center" label="合同数量" min-width="100" prop="hetongshuliang"></el-table-column>
          <el-table-column align="center" label="物料名称" min-width="100" prop="wuliaomingcheng"></el-table-column>
          <el-table-column align="center" label="单伞用量" min-width="100" prop="dansanyongliang"></el-table-column>
          <el-table-column align="center" label="单价" min-width="100" prop="danjia"></el-table-column>
          <el-table-column align="center" label="成控工价" min-width="100" prop="chengkonggongjia"></el-table-column>
          <el-table-column align="center" label="产量" min-width="100" prop="chanliang"></el-table-column>
          <el-table-column align="center" label="外协/库存" min-width="100" prop="kucun"></el-table-column>
          <el-table-column align="center" label="期初库存" min-width="100" prop="qichukucun"></el-table-column>
          <el-table-column align="center" label="期初产量" min-width="100" prop="qichuchanliang"></el-table-column>
          
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="订单号" prop="dingdanhao">
          <el-select v-model="orderValue" filterable placeholder="请选择"
            @change="orderChange" style="width: 600px;">
            <el-option v-for="item in orderSelectList"
              :key="item.dingdanhao+'_'+item.sanxing+'_'+item.guige+'_'+item.hetongshuliang"
              :label="item.dingdanhao+'_'+item.sanxing+'_'+item.guige+'_'+item.hetongshuliang"
              :value="item.dingdanhao+'_'+item.sanxing+'_'+item.guige+'_'+item.hetongshuliang">
            </el-option>
          </el-select>
          <el-input v-model="editForm.dingdanhao" style="margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item label="伞型" prop="sanxing">
          <el-input v-model="editForm.sanxing"></el-input>
        </el-form-item>
        <el-form-item label="规格" prop="guige">
          <el-input v-model="editForm.guige"></el-input>
        </el-form-item>
        <el-form-item label="合同数量" prop="hetongshuliang">
          <el-input-number v-model="editForm.hetongshuliang" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="物料名称" prop="wuliaomingcheng">
          <div style="display: flex;">
            <el-input v-model="editForm.wuliaomingcheng" style="margin-right: 10px;"></el-input>
            <el-select v-model="gongxuValue" filterable placeholder="请选择" style="width: 400px;"
              @change="gongxuChange" >
              <el-option v-for="(item,index) in gongxuSelectList"
                :key="index" :label="item.wuliaomingcheng" 
                :value="item.wuliaomingcheng">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="单伞用量" prop="dansanyongliang">
          <el-input v-model="editForm.dansanyongliang" type="number" step="0.01"></el-input>
        </el-form-item>
        <el-form-item label="单价" prop="danjia">
          <el-input-number v-model="editForm.danjia" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="成控工价" prop="chengkonggongjia">
          <el-input-number v-model="editForm.chengkonggongjia" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="外协/库存" prop="kucun">
          <el-input-number v-model="editForm.kucun" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="产量" prop="chanliang">
          <el-input-number v-model="editForm.chanliang" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        
        <el-form-item label="期初外协/库存" prop="qichukucun">
          <el-input-number v-model="editForm.qichukucun" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="期初产量" prop="qichuchanliang">
          <el-input-number v-model="editForm.qichuchanliang" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    riqi: '',
    dingdanhao: '',
    sanxing: '',
    guige: '',
    hetongshuliang: '',
    wuliaomingcheng: '',
    dansanyongliang: '',
    danjia: '',
    chengkonggongjia: '',
    chanliang: '',
    kucun: '',
    qichukucun: '',
    qichuchanliang: ''
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keyword2: "",
      keyword3: "",
      keyword4: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      orderSelectList: [],
      memberSelectList: [],
      gongxuSelectList: [],
      orderValue: '',
      gongxuValue: '',
      today: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
    this.getSelectList()
  },

  methods: {
    orderChange(e) {
      let arr = e.split('_')
      for(let i in this.orderSelectList) {
        if(this.orderSelectList[i].dingdanhao==arr[0]
          &&this.orderSelectList[i].sanxing==arr[1]
          &&this.orderSelectList[i].guige==arr[2]) {
          this.editForm.dingdanhao = this.orderSelectList[i].dingdanhao
          this.editForm.sanxing = this.orderSelectList[i].sanxing
          this.editForm.guige = this.orderSelectList[i].guige
          this.editForm.hetongshuliang = this.orderSelectList[i].hetongshuliang
          
          this.editForm.wuliaomingcheng = ''
          this.gongxuValue = ''
          this.editForm.dansanyongliang = 0
          this.editForm.danjia = 0
          this.editForm.chengkonggongjia = 0
          
          if(this.orderSelectList[i].gongxuArr) {
            this.gongxuSelectList = JSON.parse(this.orderSelectList[i].gongxuArr)
          }else{
            this.gongxuSelectList = []
          }
        }
      }
    },
    
    gongxuChange(e) {
      for(let i in this.gongxuSelectList) {
        if(this.gongxuSelectList[i].wuliaomingcheng==e) {
          this.editForm.wuliaomingcheng = this.gongxuSelectList[i].wuliaomingcheng
          this.editForm.dansanyongliang = this.gongxuSelectList[i].dansanyongliang
          this.editForm.danjia = this.gongxuSelectList[i].danjia
          this.editForm.chengkonggongjia = this.gongxuSelectList[i].chengkonggongjia
        }
      }
    },
    
    getSelectList() {
      this.$request.post('/index.php/admin/ordermodel/dadutouMbSelect').then((res) => {
        this.orderSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getMemberSelectList() {
      this.$request.post('/index.php/admin/admin/memberSelect').then((res) => {
        this.memberSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getGongxuSelectList() {
      this.$request.post('/index.php/admin/ordermodel/gongxuMbSelect').then((res) => {
        this.gongxuSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.keyword2 = ""
      this.keyword3 = ""
      this.keyword4 = ""
      this.today = ''
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      if(form.dingdanhao) {
        this.editForm.dingdanhao = form.dingdanhao
        this.editForm.sanxing = form.sanxing
        this.editForm.guige = form.guige
        this.editForm.hetongshuliang = form.hetongshuliang
      }
      if(form.wuliaomingcheng) {
        this.editForm.wuliaomingcheng = form.wuliaomingcheng
        this.editForm.dansanyongliang = form.dansanyongliang
        this.editForm.danjia = form.danjia
        this.editForm.chengkonggongjia = form.chengkonggongjia
      }
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/orderform/dadutouInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/orderform/dadutouDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/orderform/dadutouSave', data).then((res) => {
            if(res.data.code==200) {
              this.$message.success(res.data.msg)
              this.editModal = false
              this.getList()
            }else{
              this.$message.error(res.data.msg)
            }
            
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.keyword2) {
        data.keyword2 = this.keyword2
      }
      if(this.keyword3) {
        data.keyword3 = this.keyword3
      }
      if(this.keyword4) {
        data.keyword4 = this.keyword4
      }
      if(this.today) {
        data.year = this.today.getFullYear()
        data.month = this.today.getMonth()+1
        data.day = this.today.getDate()
      }
      this.$request.post('/index.php/admin/orderform/dadutouList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
